var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9891 6.36407V2.63593H12.2609L9.625 0L6.98907 2.63593H3.26093V6.36407L0.625 9L3.26093 11.6359V15.3641H6.98907L9.625 18L12.2609 15.3641H15.9891V11.6359L18.625 9L15.9891 6.36407ZM11.7606 12.6305C9.78975 12.5817 9.78975 9.68949 11.7606 9.64068C13.7314 9.68949 13.7314 12.5817 11.7606 12.6305ZM7.48941 5.36949C9.46025 5.41831 9.46025 8.31051 7.48941 8.35932C5.51856 8.31051 5.51856 5.41831 7.48941 5.36949ZM6.09212 11.6725L12.2975 5.46712L13.1579 6.32746L6.95246 12.5329L6.09212 11.6725Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferBlackIcon);
export default __webpack_public_path__ + "static/media/offer-black-icon.c27c6e871f77a136238e7fdf6d16e77d.svg";
export { ForwardRef as ReactComponent };